export default "__VITE_ASSET__CUffsNLn__"